<template>
  <div id="product-documents-wording-edit">

    <vs-alert color="danger" title="Wording Document Not Found" :active.sync="not_found">
      <span>Wording Document record with id: {{ id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'wording.list'}" class="text-inherit underline">All
        Wording Documents</router-link>
      </span>
    </vs-alert>

    <wording-form v-if="model" v-model="model" ref="form" :forms="formReferences" :apiModel="apiModel"/>

    <div class="vx-row" v-if="model">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'wording.list' })"
              class="ml-4 mt-2"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="ml-auto mt-2"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import WordingForm from "@/views/pages/product-documents/wording/WordingForm";
import ProductDocumentEditMixin from "@/components/mixins/ProductDocumentEditMixin";

export default {
  name: "WordingEdit",
  components: {
    WordingForm
  },
  mixins: [ProductDocumentEditMixin],
  data() {
    return {
      apiModel: 'productWording',
      references: ['RiskCode_FK'],
    };
  },
};
</script>

<style scoped>

</style>
